import axios from 'axios';

class ClaimStatusService {

    constructor(baseUrl = '/api/admin/v1/claimstatus') {
        this.client = axios;
        this.baseUrl = baseUrl;
    }


    // --- LOOKUPS ---

    async getStatuses() {
        const res = await this.client.get(this.baseUrl + '/statuses');
        return res.data;
    }

    async getStatusReasons() {
        const res = await this.client.get(this.baseUrl + '/status-reasons');
        return res.data;
    }

    async getAllReasons() {
        const res = await this.client.get(this.baseUrl + '/reasons');
        return res.data;
    }

    // --- HISTORY ---

    async getClaimStatusHistory(claimId, claim) {
        const res = await this.client.post(this.baseUrl + `/${claimId}/history`, claim);
        return res.data;
    }

    // --- MUTATION ---

    async setClaimStatus({ claimId, statusId, reasonId }) {
        const res = await this.client.post(this.baseUrl + '/set-status', {
            claimId,
            statusId,
            reasonId
        });
        return res.data;
    }
}

export default new ClaimStatusService();